import { isClient } from "./browser";

export interface AppleAuthConfig {
  clientId: string;
  scope: string;
  redirectURI: string;
  state: string;
  usePopup: boolean;
}

/** Apple JS SDK (Sign in with Apple). */
export const APPLE_SSO_SDK_URL =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js" as const;

export const getAppleSSOConfig = (): AppleAuthConfig => {
  const clientId = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID;
  if (!clientId) {
    throw new Error("Missing Apple SSO configuration");
  }

  const currentHost = isClient() ? window.location.host : "qrcreator.com";
  // Always HTTPS by Apple requirement
  const redirectURI = `https://${currentHost}/auth/apple/callback`;

  return {
    clientId: clientId,
    scope: "name email",
    redirectURI,
    state: `origin:${currentHost.replace(/\./g, "_")}`,
    usePopup: true,
  };
};
